<template>
  <Teleport
    v-if="activityCountdown.show"
    to=".mobile-header-wrap-1"
    :disabled="!layout.isMobile"
  >
    <Countdown
      :activity-icon="activityCountdown.activityIcon"
      :activity-text="activityCountdown.activityText"
      :expire-time="activityCountdown.expireTime"
      class="activity-top-bar"
      @link="handleLinkClick"
    />
  </Teleport>
</template>

<script lang="ts" setup>
import { getActivityOperation } from '@/api'
import track from '@/track/webYunpanPublicModule'
import { getRichText } from '@/utils/richJson'
import { onMounted, reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLayout } from '~/store/layout'
import Countdown from './ActivityContentRender.vue'

interface Props {
  scene: 'share_page' | 'invitation_page' | 'invited_page'
}

const props = defineProps<Props>()

const { locale } = useI18n()
const layout = useLayout()

const activityCountdown = reactive({
  show: false,
  expireTime: undefined,
  activityText: undefined,
  activityIcon: undefined,
})

const init = async () => {
  const { data } = await getActivityOperation(navigator.language, locale.value)

  if (!data.value || !data.value.values?.activity_operation?.activity_top_bar) return
  const activityTopBarConfig = data.value.values.activity_operation.activity_top_bar
  const activityConfig = activityTopBarConfig[props.scene]
  if (!activityConfig) return
  Object.assign(activityCountdown, {
    show: !!activityConfig.show_pay_guide_activity,
    expireTime: Number(activityConfig.pay_activity_expire_time),
    activityIcon: activityConfig.pay_guide_icon,
    activityText: activityConfig.pay_guide_activity_text || getRichText(activityConfig.pay_guide_rich_text),
  })
  if (activityCountdown.show) {
    track.spread_page_operation_show({ scene: props.scene })
  }
}

const handleLinkClick = () => {
  track.spread_page_operation_click({ scene: props.scene })
}

onMounted(init)
</script>

<style lang="less" scoped>
.activity-top-bar {
  justify-content: flex-start;
  padding: 4px 16px;
  border-radius: 8px;
  background: #fff;

  &:hover {
    background: #fafcff;
  }
}

@media screen and (max-width: 768px) {
  .activity-top-bar {
    justify-content: center;
    background: #edf7ff;
    border-radius: 0;

    &:hover {
      background: #edf7ff;
    }
  }
}
</style>
